import { useSyncExternalStore } from "react";

const COOKIE_KEY = "selected-projet-id";
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 400;

const listeners = new Set<() => void>();

function emit() {
    for (const listener of listeners) listener();
}

function subscribe(onStoreChange: () => void) {
    listeners.add(onStoreChange);
    return () => {
        listeners.delete(onStoreChange);
    };
}

function getCookie(name: string) {
    const prefix = `${encodeURIComponent(name)}=`;
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        if (cookie.startsWith(prefix)) {
            return decodeURIComponent(cookie.slice(prefix.length));
        }
    }
    return null;
}

function setCookie(name: string, value: string, maxAgeSeconds: number) {
    document.cookie = [
        `${encodeURIComponent(name)}=${encodeURIComponent(value)}`,
        "path=/",
        `max-age=${maxAgeSeconds}`,
        "SameSite=Lax",
    ].join("; ");
}

function getStoredProjetId() {
    return getCookie(COOKIE_KEY) || null;
}

export function selectProjet(id: string) {
    setCookie(COOKIE_KEY, id, COOKIE_MAX_AGE_SECONDS);
    emit();
}

export function clearSelectedProjet() {
    setCookie(COOKIE_KEY, "", 0);
    emit();
}

export function useSelectedProjetId() {
    return useSyncExternalStore(subscribe, getStoredProjetId, () => null);
}
